import React from 'react'
import { ModalProvider, type ModalProviderProps } from './ModalContext'

const withStepModalProvider = (
	Component: React.ComponentType,
	providerProps?: Omit<ModalProviderProps, 'children'>
): React.ComponentType => {
	function StepModalProviderWrapper(props: any): JSX.Element {
		return (
			<ModalProvider {...providerProps}>
				<Component {...props} />
			</ModalProvider>
		)
	}

	return StepModalProviderWrapper
}

export default withStepModalProvider
